// A League section at its own address (PLAN-2026-10-17 §4, B-403): the
// section's whole screen, grown out of its panel on the front page. The
// screen is the one it always was; this gives it the part of the page the
// panel morphs into (`shell/morph.ts`). Back in the top bar returns to the
// front page.

import type { ReactNode } from 'react';

export function LeagueSection({ children }: { children: ReactNode }) {
  return <div className="fsp-section-room">{children}</div>;
}
